import axios from "axios";
import { License } from "../models/license";

export const postLicense = async (license: License) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API}/License/license`,
      license
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
